import React, { createContext, useContext, useMemo } from 'react';
import type { StoreTypeT } from '../types/types';
export type ReviewModeContextT = {
  toggleAnnotationVisibility?: (hidden: boolean, annotationId: string, storeType?: StoreTypeT) => void;
  selectAnnotation: (annotationId: string) => void;
};
type PropsT = React.PropsWithChildren<{
  toggleAnnotationVisibility?: (hidden: boolean, annotationId: string, storeType?: StoreTypeT) => void;
  selectAnnotation: (annotationId: string) => void;
}>;
export const ReviewModeContext = createContext<ReviewModeContextT>({
  toggleAnnotationVisibility: (hidden: boolean, annotationId: string, storeType?: StoreTypeT) => {},
  selectAnnotation: (annotationId: string) => {}
});
export const ReviewModeProvider = ({
  toggleAnnotationVisibility,
  selectAnnotation,
  children
}: PropsT) => {
  const contextValue = useMemo(() => ({
    toggleAnnotationVisibility,
    selectAnnotation
  }), [toggleAnnotationVisibility, selectAnnotation]);
  return <ReviewModeContext.Provider value={contextValue}>{children}</ReviewModeContext.Provider>;
};
export const useReviewMode = () => {
  return useContext(ReviewModeContext);
};